// extracted by mini-css-extract-plugin
export default {"marginRight":"SimulationParmeterHint_marginRight__QlOks"};